import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
}), 'PlayCircleFilledWhiteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayCircleFilledWhiteSharp.js
// module id = 5510
// module chunks = 2